<!-- prettier-ignore -->

<div class="subHeaderCity">
    <h2>{{'¡Tenemos estas rutas preparadas para ti!' | translate}}</h2>
</div>
<div scrollControl #scrollDirective="scrollDirective" class="cardsScrollContainer routeScrollWrapper">
  <ci-icon-button
    type="standard" 
    name="previous"
    class="goLeftCardsScrollContainer eventGoLeft"
    scrollControl
  ></ci-icon-button>
  
  <ci-icon-button
    type="standard"
    name="next"
    class="goRightCardsScrollContainer eventGoRight"
    scrollControl
  ></ci-icon-button>
  <div class="cardsContainer eventContainer" scrollControl>
      @for (route of item; track $index) {
          <cicerone-route-card class="itemPoints" [item]="route" />
      }
  </div>
</div>